import { render, staticRenderFns } from "./form-title.vue?vue&type=template&id=67ca7e06&scoped=true&"
import script from "./form-title.vue?vue&type=script&lang=ts&"
export * from "./form-title.vue?vue&type=script&lang=ts&"
import style0 from "./form-title.vue?vue&type=style&index=0&id=67ca7e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca7e06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
